module.exports = __webpack_public_path__ + "static/Klaus-logo-65540deb39f0a8a5fd691260ea29714c.png";